import { render, staticRenderFns } from "./OtherPropertyCalculator.vue?vue&type=template&id=74581388"
import script from "./OtherPropertyCalculator.vue?vue&type=script&lang=ts"
export * from "./OtherPropertyCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports